import Api from "./baseApi";
export default {
  searchStock: Stock => {
    let url = "/api/stockDetails?v=1";
    if (Stock.search) url += `&q=${Stock.search}`;
    if (Stock.state > -1) url += `&state=${Stock.state}`;
    if (Stock.startDate) url += `&startDate=${Stock.startDate}`;
    if (Stock.endDate) url += `&endDate=${Stock.endDate}`;
    return Api.get(url);
  },
  getStockDetails: () => Api.get("/api/StockDetails"),
  getStock: id => Api.get(`/api/StockDetails/${id}`),
  putStock: Stock => Api.put(`/api/StockDetails/${Stock.id}`, Stock),
  deleteStock: Stock => Api.delete(`/api/StockDetails/${Stock.id}`, Stock),
  postStock: Stock => Api.post(`/api/StockDetails`, Stock),
  bulkUpdateStates: Model => Api.post(`/api/stockDetails/BulkStock`, Model)
};
